import type { PlaybackDeviceProfile } from '@amzn/bf-playback'
import { clientApp } from '@/device/clientApp'
import { getDeviceConfig } from '@/device/deviceConfig'
import { bullfrogVersion } from '@/version'

// Each field reads through when used, so a reader of one field doesn't resolve the rest.
export function createWebPlaybackDeviceProfile(readDeviceId: () => string): PlaybackDeviceProfile {
    return {
        get deviceType() {
            return getDeviceConfig().deviceType
        },
        get deviceTypeId() {
            return getDeviceConfig().deviceTypeId
        },
        get deviceId() {
            return readDeviceId()
        },
        appVersion: bullfrogVersion.str,
        clientApp,
        get locale() {
            return navigator.language
        },
        get viewport() {
            return { width: window.innerWidth, height: window.innerHeight }
        },
        get webKit() {
            return getDeviceConfig().webKit
        },
        get streamingOptions() {
            return getDeviceConfig().streamingOptions
        },
        get performanceTier() {
            return getDeviceConfig().performanceTier
        },
    }
}
